import { NotAvailableDialogComponent } from 'src/app/shared/components/not-available-dialog/not-available-dialog.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-share-in-our-database',
  templateUrl: './share-in-our-database.component.html',
  styleUrls: ['./share-in-our-database.component.scss']
})
export class ShareInOurDatabaseComponent implements OnInit {

  @ViewChild('sidenav') sidenav: MatSidenav;

  page = 1;

  constructor(
    private route: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.openDialog();
  }

  openNav() {
    this.sidenav.open();
  }

  closeNav() {
    this.sidenav.close();
  }

  openDialog(): void {
    this.dialog.open(NotAvailableDialogComponent);
  }

  continueToForm() {
    this.route.navigateByUrl('/share-in-our-database/capture');
  }
}
